<template>
  <div class="diagram-legend">
    <div
      v-for="(legend, index) in legends"
      v-bind:key="`legend-${index}`"
      class="diagram-legend__unit"
    >
      <div
        :style="{ 'border-color': legend.color }"
        class="diagram-legend__icon"
      />
      <div class="diagram-legend__text">
        <span>
          {{ legend.label }}
        </span>
        <span>
          {{ legend.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description Генератор цветов
 * @return {Generator<string, void, *>}
 */
function* colorGenerator() {
  const colors = [
    '#0489E0',
    '#ff0000',
    '#D9E1EC',
    '#7371FF',
    '#EC782A',
    '#28b600',
    '#7f00af',
  ];
  let i = 0;
  while (i < colors.length) {
    const color = colors[i];
    yield color;
    i += 1;
    if (i === colors.length) {
      i = 0;
    }
  }
}

/**
 * @description Легенда для диаграммы
 */
export default {
  computed: {
    legends() {
      const colorVendor = colorGenerator();
      return this.items.map((item) => ({
        label: item.label,
        value: item.valueTitle,
        color: colorVendor.next().value,
      }));
    },
  },
  name: 'DiagramLegend',
  props: {
    /**
     * @description Данные легенд
     * @type {Array}
     */
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.diagram-legend {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  &__unit {
    display: flex;
    gap: 10px;
    align-items: center;
    color: #707683;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  &__icon {
    width: 20px;
    min-width: 20px;
    height: 20px;
    min-height: 20px;
    border-radius: 50%;
    border-width: 2px;
    border-style: solid;
  }
  &__text {
    display: flex;
    flex-flow: row nowrap;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    span:last-child {
      flex-shrink: 0;
      color: #323C47;
      font-weight: 700;
    }
  }
}
@media screen and (max-width: 1420px) {
  .diagram-legend {
    &__text {
      justify-content: flex-start;
      gap: 20px;
    }
  }
}

@media screen and (max-width: 480px) {
  .diagram-legend {
    &__text {
      flex-wrap: wrap;
    }
  }
}
</style>
